// --- React Import
import React from 'react';
// --- UI Components
import Button from '@dtci/spellbook/Button';
// --- Utility Function
import {usePermissions} from '../../../utils/permissions';

/**
 * CMActionButtonsRenderer Component
 *
 * This component is responsible for rendering action buttons in a grid cell.
 * It provides different buttons based on the user's permissions and the data passed to it.
 *
 * @param {Function} onOpenCreateModal - Function to open the creation modal.
 * @param {Function} onOpenEditModal - Function to open the edit modal.
 * @param {Function} onOpenViewModal - Function to open the view modal.
 * @param {Function} onOpenDeleteModal - Function to open the delete modal.
 * @returns {Function} - A renderer function that returns the appropriate action buttons based on the user's permissions and data.
 */
export const CMActionButtonsRenderer = (
    onOpenCreateModal,
    onOpenEditModal,
    onOpenViewModal,
    onOpenDeleteModal,
) => {
    return function Renderer({value, data}) {
        const {isLegalAdmin, isProductCommentsAdmin} = usePermissions();

        return (
            <>
                {(isLegalAdmin && data?.legalStatusId == null) && (
                    <Button
                        style={{paddingRight: 10, color: '#3611c8'}}
                        type="button"
                        styleType="link"
                        className="sb-typography sb-typography_T20 sb-typography_truncate"
                        onClick={onOpenEditModal(data)}
                    >
                        CREATE
                    </Button>
                )}
                {((isLegalAdmin || isProductCommentsAdmin) && data.legalStatusId !== null) && (
                    <>
                        <Button
                            style={{paddingRight: 10, color: '#3611c8'}}
                            type="button"
                            styleType="link"
                            className="sb-typography sb-typography_T20 sb-typography_truncate"
                            onClick={onOpenEditModal(data)}
                        >
                            EDIT
                        </Button>
                        <Button
                            style={{paddingRight: 10, color: '#3611c8'}}
                            type="button"
                            styleType="link"
                            className="sb-typography sb-typography_T20 sb-typography_truncate"
                            onClick={onOpenViewModal(data)}
                        >
                            VIEW
                        </Button>
                    </>
                )}
                {(isLegalAdmin && data.legalStatusId != null) && (
                    <Button
                        style={{paddingRight: 10, color: '#3611c8'}}
                        type="button"
                        styleType="link"
                        className="sb-typography sb-typography_T20 sb-typography_truncate"
                        onClick={onOpenDeleteModal(data)}
                    >
                        DELETE
                    </Button>
                )}
            </>
        );
    };
};